import { Flex, FlexItem, Text } from "@fluentui/react-northstar";

import CoreLogo from "../../../../../../_shared/assets/polly-logo-no-text.svg";

type Props = {
  title: string;
};

export const Header: React.FC<Props> = props => {
  const appName = "Polly";

  return (
    <Flex gap="gap.medium" className="header">
      <FlexItem>
        <div
          style={{
            padding: "8px 8px 0",
            backgroundColor: "rgba(0, 0, 0, 0.03)",
            borderRadius: "0.4rem",
          }}
        >
          <img src={CoreLogo} height={24} alt="Polly" />
        </div>
      </FlexItem>

      <FlexItem>
        <div>
          <Text weight="bold">{appName}</Text>
          <br />
          <Text>
            {appName}: {props.title}
          </Text>
        </div>
      </FlexItem>
    </Flex>
  );
};
